// Styled Components
import styled from "styled-components";

const InfoFiveArena = () => {
  return (
    <Wrapper>
      <img
        src="https://cdn.discordapp.com/attachments/896285560094748713/909584375497236500/Screenshot_2021-11-14_234046.jpg"
        alt=""
      />
    </Wrapper>
  );
};

export default InfoFiveArena;

const Wrapper = styled.div`
  position: relative;

  img {
    //   height: 100vh;
    //   width: 100vw;
    width: 100vw;
  }

  .background {
    //   position: absolute;
    //  top: 0;
    //  left: 0;

    //    width: 100%;
    //   z-index: -1;
  }
`;
